// import * as React from 'react';
import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { headerData } from "../data/headerCostum";
import { useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Divider,
  Chip,
  Avatar
} from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import { useLocalStorage } from "../auth/useLocalStorage";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import MapIcon from "@mui/icons-material/Map";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="#FFFFFF"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://makassarkota.go.id/">
        Pemerintah Kota Makassar
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#1dc39f',
    },
    secondary: {
      main: '#8ff9ab',
    },
    background: {
      default: '#f8fffe',
    },
  },
  typography: {
    h4: {
      fontWeight: 700,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            backgroundColor: 'white',
            '&:hover fieldset': {
              borderColor: '#1dc39f',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1dc39f',
            },
          },
        },
      },
    },
  },
});

const CekLongwis = () => {
  const navigate = useNavigate();

  const [swalProps, setSwalProps] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({
    id: null,
    kecamatan: null,
    kelurahan: null,
    longwis: null,
    alamat: null,
    nama_pic: '',
    kontak_pic: '',
    tanggal: null,
    lokasi: [0, 0],
    status: ''
  });

  const [kecamatan, setKecamatan] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }]);

  const [kelurahan, setKelurahan] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }]);

  const [data_longwis, setDataLongwis] = useState([{
    id: 1,
    nama: 'Mohon Tunggu . . .'
  }]);

  const [list_longwis, setListLongwis] = useState(null)

  const [loklongwis, setLokLongwis] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => {
    event.preventDefault();
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getLongwisData = () => {
    setLoading(true);
    setError(null);

    fetch(process.env.REACT_APP_API_URL + "api/longwis", {
      method: "get",
      headers: headerData
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Gagal mengambil data longwis');
        }
        return res.json();
      })
      .then((res) => {
        if (res) {
          setListLongwis(res);
          getKecData(res);
        } else {
          throw new Error('Data longwis tidak ditemukan');
        }
      })
      .catch((err) => {
        console.error('Error fetching longwis data:', err);
        setError(err.message || 'Terjadi kesalahan saat mengambil data');
        setSwalProps({
          show: true,
          title: "Gagal",
          icon: "error",
          text: err.message || "Terjadi kesalahan saat mengambil data",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const getKecData = useCallback((data) => {
    let kecamatan = [];
    let dataKecamatan = [];
    data.forEach((items) => {
      let indx = 0
      if (kecamatan.includes(items.kecamatan)) {
        return
      } else {
        kecamatan.push(items.kecamatan)
        dataKecamatan.push({ nama: items.kecamatan, id: indx });
        indx += 1;
      }
    })
    setKecamatan(dataKecamatan)
  }, [setKecamatan])

  const kecHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item => item.kecamatan === e.nama);
      let kelurahan = [];
      let dataKelurahan = [];
      filteredData.forEach((items) => {
        let indx = 0
        if (kelurahan.includes(items.kelurahan)) {
          return
        } else {
          kelurahan.push(items.kelurahan)
          dataKelurahan.push({ nama: items.kelurahan, id: indx });
          indx += 1;
        }
      })
      setKelurahan(dataKelurahan);
    }
  }, [list_longwis, setKelurahan]);

  const kelHandle = useCallback((e) => {
    if (e) {
      const filteredData = [...list_longwis].filter(item => item.kelurahan === e.nama);
      let longwis = [];
      let dataLongwis = [];
      filteredData.forEach((items, index) => {
        if (longwis.includes(items.nama_longwis)) {
          return
        } else {
          longwis.push(items.nama_longwis) // ✅ FIXED: items.nama_longwis instead of items.kelurahan
          dataLongwis.push({ nama: items.nama_longwis, id: index });
        }
      })
      setDataLongwis(dataLongwis);
    }
  }, [list_longwis, setDataLongwis]);

  const alamatHanlde = useCallback((e) => {
    if (e && list_longwis) {
      console.log('Selected longwis:', e);
      console.log('Available longwis data:', list_longwis);

      const filteredData = list_longwis.filter(item => item.nama_longwis === e.nama);
      console.log('Filtered data:', filteredData);

      if (filteredData.length > 0) {
        const selectedItem = filteredData[0]; // Ambil item pertama yang cocok
        console.log('Selected item full data:', selectedItem);

        setLokLongwis(selectedItem.LokLongwi);

        // Handle lokasi - check if it's already an array or needs parsing
        let lokasiData = [0, 0]; // default fallback
        try {
          if (Array.isArray(selectedItem.lokasi)) {
            // Already an array
            lokasiData = selectedItem.lokasi;
          } else if (typeof selectedItem.lokasi === 'string' && selectedItem.lokasi.trim() !== '') {
            // String that needs parsing
            lokasiData = JSON.parse(selectedItem.lokasi);
          }
        } catch (error) {
          console.error('Error parsing lokasi:', error);
          lokasiData = [0, 0];
        }

        console.log('Setting data with:', {
          id: selectedItem.id,
          nama_pic: selectedItem.nama_pic,
          kontak_pic: selectedItem.kontak_pic,
          alamat: selectedItem.alamat,
          lokasi: lokasiData
        });

        // Check all possible field names for debugging
        console.log('All available fields in selectedItem:', Object.keys(selectedItem));
        console.log('nama_pic field variations:', {
          nama_pic: selectedItem.nama_pic,
          pic_name: selectedItem.pic_name,
          namaPic: selectedItem.namaPic
        });
        console.log('kontak_pic field variations:', {
          kontak_pic: selectedItem.kontak_pic,
          pic_contact: selectedItem.pic_contact,
          kontakPic: selectedItem.kontakPic,
          phone: selectedItem.phone,
          telp: selectedItem.telp
        });
        console.log('alamat field variations:', {
          alamat: selectedItem.alamat,
          address: selectedItem.address,
          lokasi_alamat: selectedItem.lokasi_alamat
        });

        // Debug: Show the raw field values before processing
        console.log('Raw field access test:', {
          'selectedItem.nama_pic': selectedItem.nama_pic,
          'selectedItem.kontak_pic': selectedItem.kontak_pic,
          'selectedItem.alamat': selectedItem.alamat,
          'typeof nama_pic': typeof selectedItem.nama_pic,
          'typeof kontak_pic': typeof selectedItem.kontak_pic,
          'typeof alamat': typeof selectedItem.alamat
        });

        // Check if we need to use different field names based on the data structure
        let nama_pic_value = selectedItem.nama_pic || selectedItem.pic_name || selectedItem.namaPic || '';
        let kontak_pic_value = selectedItem.kontak_pic || selectedItem.pic_contact || selectedItem.kontakPic || selectedItem.phone || selectedItem.telp || '';
        let alamat_value = selectedItem.alamat || selectedItem.address || selectedItem.lokasi_alamat || '';
        
        // If the main fields are empty, try to get from nested objects or alternative sources
        if (!nama_pic_value && selectedItem.longwis && selectedItem.longwis.nama) {
          nama_pic_value = selectedItem.longwis.nama;
        }
        
        // If still empty, try other possible sources
        if (!alamat_value) {
          // Check if there's an address in the location data
          if (selectedItem.LokLongwi && selectedItem.LokLongwi.alamat) {
            alamat_value = selectedItem.LokLongwi.alamat;
          }
        }

        console.log('Processed field values:', {
          nama_pic_value,
          kontak_pic_value,
          alamat_value
        });

        // Force component re-render by updating state in multiple steps
        setData(prevData => {
          const newData = {
            ...prevData,
            id: selectedItem.id,
            longwis: e, // Make sure to set the longwis value properly
            nama_pic: nama_pic_value || 'Tidak tersedia',
            kontak_pic: kontak_pic_value || 'Tidak tersedia',
            alamat: alamat_value || 'Tidak tersedia',
            lokasi: lokasiData
          };
          
          console.log('✅ Final state being set:', newData);
          
          return newData;
        });
        
        // Force component re-render
        setForceUpdate(prev => prev + 1);
      } else {
        console.warn('No matching longwis found for:', e.nama);
      }
    }
  }, [list_longwis]);

  const sendData = () => {
    setSwalProps({
      show: true,
      title: "Sukses",
      icon: "success",
      text: "Data telah ditambahkan",
    });
    setOpenDialog(false);
  };



  useEffect(() => {
    if (!list_longwis) {
      getLongwisData();
    }
  }, [list_longwis, getLongwisData]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e8f5e8 0%, #f0fff0 100%)",
        py: 4
      }}
    >
      <ThemeProvider theme={defaultTheme}>
        <Container component="main" maxWidth="md">
          <CssBaseline />
          <SweetAlert2
            {...swalProps}
            didClose={() => {
              setSwalProps({});
            }}
          />

          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              sx: {
                borderRadius: 3,
                minWidth: '400px'
              }
            }}
          >
            <DialogTitle
              align="center"
              sx={{
                justifyItems: "center",
                color: 'primary.main',
                fontWeight: 600,
                pb: 1
              }}
              id="alert-dialog-title"
            >
              🔍 Konfirmasi Data
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <DialogContentText
                id="alert-dialog-description"
                sx={{
                  textAlign: 'center',
                  fontSize: '16px',
                  color: 'text.primary'
                }}
              >
                Apakah Anda yakin bahwa data longwis yang dipilih sudah sesuai?
              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={{
                justifyContent: "space-between",
                px: 3,
                pb: 3
              }}
            >
              <Button
                variant="outlined"
                onClick={handleCloseDialog}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  borderColor: '#ef4444',
                  color: '#ef4444',
                  '&:hover': {
                    backgroundColor: '#ef4444',
                    color: 'white'
                  }
                }}
              >
                Kembali
              </Button>
              <Button
                variant="contained"
                onClick={sendData}
                autoFocus
                sx={{
                  borderRadius: 2,
                  px: 3,
                  backgroundColor: "primary.main",
                  '&:hover': {
                    backgroundColor: "primary.dark",
                  }
                }}
              >
                Ya, Lanjutkan
              </Button>
            </DialogActions>
          </Dialog>

          <Paper
            elevation={8}
            sx={{
              p: 4,
              borderRadius: 3,
              background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 100%)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}
          >
            {/* Header */}
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  backgroundColor: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                  mb: 2,
                  boxShadow: 3
                }}
              >
                <SearchIcon sx={{ fontSize: 40, color: 'white' }} />
              </Box>

              <Typography component="h1" variant="h4" sx={{ mb: 1, color: 'primary.main', fontWeight: 700 }}>
                Pilih Longwis
              </Typography>

              <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary', textAlign: 'center' }}>
                Pilih kecamatan, kelurahan, dan nama longwis untuk melihat detail informasi
              </Typography>

              {/* Error Alert */}
              {error && (
                <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
                  {error}
                </Alert>
              )}

              {/* Loading Alert */}
              {loading && (
                <Alert severity="info" sx={{ mb: 3, borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <CircularProgress size={20} />
                    Memuat data longwis...
                  </Box>
                </Alert>
              )}
            </Box>

            <Grid container spacing={4}>
              {/* Form Section */}
              <Grid item xs={12} lg={6}>
                <Card sx={{ height: '100%', border: '1px solid', borderColor: 'primary.light', borderRadius: 2 }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <LocationOnIcon color="primary" sx={{ mr: 1 }} />
                      <Typography variant="h6" fontWeight={600}>Form Pencarian</Typography>
                    </Box>

                    <Box component="form" onSubmit={handleOpenDialog}>
                      <Autocomplete
                        disablePortal
                        id="kecamatan"
                        options={kecamatan || []}
                        value={data.kecamatan}
                        getOptionLabel={(option) => option.nama || ''}
                        onChange={(event, newValue) => {
                          kecHandle(newValue);
                          setData({ ...data, kecamatan: newValue });
                        }}
                        disabled={loading}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            margin="normal"
                            {...params}
                            fullWidth
                            size="medium"
                            label="Kecamatan"
                            placeholder="Pilih Kecamatan"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: <BusinessIcon color="action" sx={{ mr: 1 }} />,
                            }}
                          />
                        )}
                      />

                      <Autocomplete
                        disablePortal
                        id="kelurahan"
                        options={kelurahan || []}
                        value={data.kelurahan}
                        getOptionLabel={(option) => option.nama || ''}
                        onChange={(event, newValue) => {
                          kelHandle(newValue);
                          setData({ ...data, kelurahan: newValue });
                        }}
                        disabled={loading || !data.kecamatan}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            margin="normal"
                            {...params}
                            fullWidth
                            size="medium"
                            label="Kelurahan"
                            placeholder="Pilih Kelurahan"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: <HomeIcon color="action" sx={{ mr: 1 }} />,
                            }}
                          />
                        )}
                      />

                      <Autocomplete
                        disablePortal
                        id="longwis"
                        options={data_longwis || []}
                        value={data.longwis}
                        getOptionLabel={(option) => option.nama || ''}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            alamatHanlde(newValue);
                            // Note: alamatHanlde will handle setting the longwis value
                          } else {
                            // Reset when no value selected
                            setData({ ...data, longwis: null, nama_pic: '', kontak_pic: '', alamat: null });
                            setLokLongwis(null);
                          }
                        }}
                        disabled={loading || !data.kelurahan}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            margin="normal"
                            {...params}
                            fullWidth
                            size="medium"
                            label="Nama Lorong Wisata"
                            placeholder="Pilih Longwis"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: <LocationOnIcon color="action" sx={{ mr: 1 }} />,
                            }}
                          />
                        )}
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Details Section */}
              <Grid item xs={12} lg={6}>
                <Card sx={{ height: '100%', border: '1px solid', borderColor: 'primary.light', borderRadius: 2 }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                      <PersonIcon color="primary" sx={{ mr: 1 }} />
                      <Typography variant="h6" fontWeight={600}>Detail Longwis</Typography>
                    </Box>

                    {data.longwis ? (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: 'primary.light' }}>
                            <HomeIcon />
                          </Avatar>
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Alamat
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {data.alamat || 'Tidak tersedia'}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: 'secondary.light' }}>
                            <PersonIcon />
                          </Avatar>
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Nama PIC
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {data.nama_pic || 'Tidak tersedia'}
                            </Typography>
                          </Box>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                          <Avatar sx={{ bgcolor: 'success.light' }}>
                            <PhoneIcon />
                          </Avatar>
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Kontak PIC
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                              {data.kontak_pic || 'Tidak tersedia'}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          textAlign: 'center',
                          py: 4,
                          color: 'text.secondary'
                        }}
                      >
                        <SearchIcon sx={{ fontSize: 60, mb: 2, opacity: 0.3 }} />
                        <Typography variant="body1">
                          Silakan pilih longwis untuk melihat detail
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            {/* Map and Photos Section */}
            {loklongwis && (
              <Card sx={{ mt: 4, border: '1px solid', borderColor: 'primary.light', borderRadius: 2 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <MapIcon color="primary" sx={{ mr: 1 }} />
                    <Typography variant="h6" fontWeight={600}>Lokasi & Dokumentasi</Typography>
                  </Box>

                  <Grid container spacing={3}>
                    {/* Map */}
                    <Grid item xs={12} md={6}>
                      <Box sx={{ mb: 2 }}>
                        <Chip
                          icon={<MapIcon />}
                          label="Peta Lokasi"
                          color="primary"
                          sx={{ mb: 2 }}
                        />
                      </Box>
                      <Box
                        sx={{
                          borderRadius: 2,
                          overflow: 'hidden',
                          border: '1px solid',
                          borderColor: 'grey.300'
                        }}
                      >
                        <iframe
                          src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDdiIytgxmGyRmnGV3_0rBmKPQWU9M7Gkk&q=${data.lokasi[0]},${data.lokasi[1]}`}
                          width="100%"
                          height="300"
                          style={{ border: 0 }}
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Lokasi Longwis"
                        />
                      </Box>
                    </Grid>

                    {/* Photos */}
                    <Grid item xs={12} md={6}>
                      <Box sx={{ mb: 2 }}>
                        <Chip
                          icon={<PhotoLibraryIcon />}
                          label="Dokumentasi Foto"
                          color="secondary"
                          sx={{ mb: 2 }}
                        />
                      </Box>
                      <Grid container spacing={2}>
                        {(() => {
                          // Safe JSON parsing for photos
                          try {
                            const photoData = typeof loklongwis.file_foto === 'string'
                              ? loklongwis.file_foto.trim()
                              : loklongwis.file_foto;

                            if (!photoData || photoData === '' || photoData === 'null') {
                              return (
                                <Grid item xs={12}>
                                  <Box
                                    sx={{
                                      textAlign: 'center',
                                      py: 4,
                                      color: 'text.secondary',
                                      border: '1px dashed',
                                      borderColor: 'grey.300',
                                      borderRadius: 2
                                    }}
                                  >
                                    <PhotoLibraryIcon sx={{ fontSize: 40, mb: 1, opacity: 0.3 }} />
                                    <Typography variant="body2">
                                      Tidak ada dokumentasi foto
                                    </Typography>
                                  </Box>
                                </Grid>
                              );
                            }

                            const parsedPhotos = JSON.parse(photoData);
                            const photoArray = Array.isArray(parsedPhotos) ? parsedPhotos : [];

                            if (photoArray.length === 0) {
                              return (
                                <Grid item xs={12}>
                                  <Box
                                    sx={{
                                      textAlign: 'center',
                                      py: 4,
                                      color: 'text.secondary',
                                      border: '1px dashed',
                                      borderColor: 'grey.300',
                                      borderRadius: 2
                                    }}
                                  >
                                    <PhotoLibraryIcon sx={{ fontSize: 40, mb: 1, opacity: 0.3 }} />
                                    <Typography variant="body2">
                                      Tidak ada dokumentasi foto
                                    </Typography>
                                  </Box>
                                </Grid>
                              );
                            }

                            return photoArray.map((items, index) => (
                              <Grid item xs={6} key={index}>
                                <Box
                                  sx={{
                                    position: 'relative',
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    border: '1px solid',
                                    borderColor: 'grey.300',
                                    '&:hover': {
                                      transform: 'scale(1.02)',
                                      transition: 'transform 0.2s ease'
                                    }
                                  }}
                                >
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}uploads/lokasi/${items}`}
                                    alt={`Dokumentasi ${index + 1}`}
                                    width="100%"
                                    height="120"
                                    style={{
                                      objectFit: 'cover',
                                      display: 'block'
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none';
                                    }}
                                  />
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      bottom: 0,
                                      left: 0,
                                      right: 0,
                                      background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                                      color: 'white',
                                      p: 1,
                                      fontSize: '12px',
                                      textAlign: 'center'
                                    }}
                                  >
                                    Foto {index + 1}
                                  </Box>
                                </Box>
                              </Grid>
                            ));
                          } catch (error) {
                            console.warn('Error parsing photo JSON:', error);
                            console.warn('Raw photo data:', loklongwis.file_foto);
                            return (
                              <Grid item xs={12}>
                                <Box
                                  sx={{
                                    textAlign: 'center',
                                    py: 4,
                                    color: 'error.main',
                                    border: '1px dashed',
                                    borderColor: 'error.main',
                                    borderRadius: 2
                                  }}
                                >
                                  <PhotoLibraryIcon sx={{ fontSize: 40, mb: 1, opacity: 0.3 }} />
                                  <Typography variant="body2">
                                    Error memuat dokumentasi foto
                                  </Typography>
                                </Box>
                              </Grid>
                            );
                          }
                        })()}
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}

            {/* Action Buttons */}
            <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
              <Button
                variant="outlined"
                onClick={() => navigate('/')}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  borderWidth: 2,
                  borderColor: 'secondary.main',
                  color: 'secondary.main',
                  '&:hover': {
                    borderWidth: 2,
                    backgroundColor: 'secondary.main',
                    color: 'white'
                  }
                }}
              >
                Kembali ke Home
              </Button>

            </Box>

            <Copyright sx={{ mt: 4 }} />
          </Paper>
        </Container>
      </ThemeProvider>
    </Box>
  );
};

export default CekLongwis;
